export default "__VITE_ASSET__CEhr57ba__"